module.exports = __webpack_public_path__ + "media/images/service en chambre 24h-24-e1c9606d7f02c8858bcfa02373f33ea0.svg";